import { styled } from '@/lib/utils'

export const ConnectionsGrid = styled('div')(
  'grid grid-cols-1 xl:grid-cols-2 gap-4'
)
